import React from "react";
import { Row, Col } from "antd";
import { Package } from "lucide-react"; // icon (you can replace with any Lucide icon)

function WhyChooseUs() {
  const features = [
    {
      title: "Premium Print Quality",
      description:
        "Experience vibrant, long-lasting prints that stay sharp wash after wash. We use advanced printing technology and top-grade materials to ensure every design looks flawless.",
    },
    {
      title: "Easy Customization",
      description:
        "Our intuitive online design tool makes creating your custom T-shirt effortless. Upload your artwork, add text, and preview your design in real time — no design skills required!",
    },
    {
      title: "Fast & Reliable Delivery",
      description:
        "From small orders to bulk prints, we pride ourselves on quick turnaround times and dependable shipping, so your custom apparel arrives exactly when you need it.",
    },
    {
      title: "Local Experts, Global Reach",
      description:
        "Proudly based in California, we serve both local businesses and international clients — combining local craftsmanship with global quality standards.",
    },
  ];

  return (
    <section className="py-16 bg-white text-dev-choose">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h4 className="font-custom text-[22px] text-gray-600">Why Choose Us</h4>
          <h2 className="font-custom text-[40px] font-bold text-gray-900">
            Why Choose Us
          </h2>
        </div>

        <Row gutter={[24, 24]} justify="center">
          {features.map((feature, index) => (
            <Col key={index} xs={24} sm={12} md={12} lg={6}>
              <div className="bg-white border rounded-2xl shadow-sm p-6 h-full hover:shadow-lg transition-shadow duration-300 text-center">
                <div className="flex justify-center mb-4">
                  <Package size={48} className="text-teal-500" />
                </div>
                <h3 className="font-semibold text-lg mb-3">{feature.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}

export default WhyChooseUs;
